// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var inject = allVue.inject;
import { getDefaultSlots } from '@progress/kendo-vue-common';
import { Reveal } from '@progress/kendo-vue-animation';
/**
 * Represents the default `GridColumnMenuItemContent` component.
 */

var GridColumnMenuItemContent = {
  props: {
    show: Boolean
  },
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var _this = this;

    var h = gh || createElement;
    var defaultSlot = getDefaultSlots(this);
    return h("div", {
      "class": 'k-columnmenu-item-content'
    }, [// @ts-ignore function children
    h(Reveal, {
      appear: this.$props.show,
      attrs: this.v3 ? undefined : {
        appear: this.$props.show
      },
      style: {
        position: 'relative',
        display: 'block'
      }
    }, this.v3 ? function () {
      return [_this.$props.show ? defaultSlot : null];
    } : [_this.$props.show ? defaultSlot : null])]);
  }
};
export { GridColumnMenuItemContent };


//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-vue-grid/dist/es/columnMenu/GridColumnMenuItemContent.js
// module id = 379
// module chunks = 93